import { FC } from 'react'

import { ControlGroup, ControlGroupHolder, ControlGroupItem } from '@plurall/elo-beta'

import { REGISTER_ICON_VARIATION } from '../../utils'

type RegisterProps = {
  handleRegisterOptionClick: (url: string) => void
  handleOpenModal: () => void
}

const Register: FC<RegisterProps> = ({ handleRegisterOptionClick, handleOpenModal }) => (
  <ControlGroup noCard>
    <ControlGroupHolder divider>
      <ControlGroupItem
        icon='user-female'
        variant={REGISTER_ICON_VARIATION}
        navigationItem
        dataTestId='btn-student-instructions'
        onClick={handleOpenModal}
      >
        Alunos
      </ControlGroupItem>
    </ControlGroupHolder>

    <ControlGroupHolder divider>
      <ControlGroupItem
        icon='teacher'
        variant={REGISTER_ICON_VARIATION}
        navigationItem
        dataTestId='btn-teacher-register'
        onClick={() =>
          handleRegisterOptionClick(
            `${process.env.REACT_APP_SOMOS_ONBOARDING_URL}/cadastro/codigo-acesso/equipe-escolar`,
          )
        }
      >
        Professor e Equipe escolar
      </ControlGroupItem>
    </ControlGroupHolder>

    <ControlGroupHolder divider>
      <ControlGroupItem
        icon='users-eye'
        variant={REGISTER_ICON_VARIATION}
        navigationItem
        dataTestId='btn-register-responsible'
        onClick={() =>
          handleRegisterOptionClick(
            `${process.env.REACT_APP_SOMOS_ONBOARDING_URL}/cadastro/responsavel`,
          )
        }
      >
        Responsável
      </ControlGroupItem>
    </ControlGroupHolder>

    <ControlGroupHolder>
      <ControlGroupItem
        icon='barcode-scan'
        variant={REGISTER_ICON_VARIATION}
        navigationItem
        dataTestId='btn-access-code'
        onClick={() =>
          handleRegisterOptionClick(
            `${process.env.REACT_APP_SOMOS_ONBOARDING_URL}/cadastro/codigo-acesso/livro`,
          )
        }
      >
        Código de material
      </ControlGroupItem>
    </ControlGroupHolder>
  </ControlGroup>
)

export default Register
